import { PageCard } from "@/components/layout/PageCard";
import { SavedListDetailView } from "@/components/saved-lists/SavedListDetailView";
import { SavedListsIndexView } from "@/components/saved-lists/SavedListsIndexView";
import { createRoute, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";

import { layoutRoute } from "../$layoutRoute";
import { savedListsSearchSchema } from "./saved-lists-search";

// The salon's Saved Lists (F3). This replaced the old `wishlist` stub. It is a
// main-sidebar destination, so it hangs off `layoutRoute` rather than the
// account shell (no account sub-nav around it); the URL stays
// `/account/saved-lists` so existing links keep working.
export const accountSavedListsRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: "account/saved-lists",
  component: AccountSavedListsPage,
  validateSearch: savedListsSearchSchema
});

/**
 * Saved Lists (F3, #59). Index of the salon's reorder lists, with a detail
 * view (live price/availability + add-to-cart) selected by `?list=<id>`.
 */
function AccountSavedListsPage() {
  const { list: selectedListId } = accountSavedListsRoute.useSearch();
  const navigate = useNavigate();

  // Opening a list pushes a history entry, so Back closes it.
  const openList = useCallback(
    (listId: string) => {
      navigate({ to: "/account/saved-lists", search: { list: listId } });
    },
    [navigate]
  );

  // Leaving via the in-page controls replaces the entry: the detail it would
  // otherwise leave behind is a deleted list after `onDeleted`.
  const closeList = useCallback(() => {
    navigate({ to: "/account/saved-lists", search: {}, replace: true });
  }, [navigate]);

  return (
    <PageCard>
      {selectedListId ? (
        <SavedListDetailView
          listId={selectedListId}
          onBack={closeList}
          onDeleted={closeList}
        />
      ) : (
        <SavedListsIndexView onSelect={openList} />
      )}
    </PageCard>
  );
}
